export default __webpack_public_path__ + "static/media/feedback_white.1e091f3f.svg";